<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <div>
        <v-tabs
                v-model="tab"
                align-with-title
                background-color="white">
            <v-tabs-slider color="blue"/>
            <v-tab
                    v-for="(item, index) in tabItems"
                    :class="{active: currentTab === index}"
                    @click="currentTab = index"
                    :key="item">
                {{ item }}
            </v-tab>
        </v-tabs>
        <div v-show="currentTab === 0"><UserProfileTab/></div>
        <div v-show="currentTab === 1"><ChangePasswordTab/></div>
        <div v-show="currentTab === 2"><UserCustomizationTab/></div>
        <div v-show="currentTab === 3"><UserBillingTab/></div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import UserProfileTab from '@/components/user-profile-tab'
    import ChangePasswordTab from '@/views/auth/change-password-tab'
    import UserCustomizationTab from '@/components/user-customization-tab'
    import UserBillingTab from '@/components/user-billing-tab'

    export default
    {
        name: 'settings',
        components:
        {
            UserProfileTab,
            ChangePasswordTab,
            UserCustomizationTab,
            UserBillingTab
        },
        data: function()
        {
            return {
                tab: null,
                currentTab: 0
            }
        },
        mounted()
        {
            // Goto the billing tab if requested and not an org user account
            if (this.$route.query.tab && !this.currentUserChanges.orgId)
            {
                this.currentTab = parseInt(this.$route.query.tab)
            }
        },
        computed:
        {
            ...mapState('auth',
            {
                currentUserChanges: state => state.currentUserChanges ? state.currentUserChanges : {healthCareProfessional: false}
            }),
            tabItems()
            {
                let tabItems = ['Profile'];
                tabItems.push('Change Password');
                if (this.currentUserChanges.healthCareProfessional)
                {
                    tabItems.push('Customize');
                    tabItems.push('Billing')
                }
                return tabItems
            }
        }
    }
</script>